import styled from 'theme';

export const AddCertificateWrapper = styled.div``;

export const AddCertificateButton = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.variables.customColors.lightNavy};

  &:hover {
    color: ${props => props.theme.variables.customColors.navy};
  }
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  line-height: 1.25;
  cursor: pointer;
  font-size: ${props => props.theme.variables.fonts.size.smaller1};
  font-weight: ${props => props.theme.variables.fonts.weight.light};

  img {
    width: 1.5em;
    margin-left: 0.4rem;
  }
`;
